import store from '@/vuex/store'

import MainPage from './pages'
import RequestMain from './pages/RequestMain'
import HistoryLicenseDetail from './pages/HistoryLicenseDetail'
import PendingApprovalDetail from './pages/PendingApprovalDetail'
import PendingApproval from './pages/PendingApproval'
import ManagerLanding from './pages/ManagerLanding'
import LicensesSearch from './pages/LicensesSearch'
import BalancesPage from './pages/BalancesPage'
import HolidaysPage from './pages/HolidaysPage'
import LicensesManagerPage from './pages/LicencesManagerPage.vue'
// import PendingApprovalCalendar from './components/pending/PendingCalendar.vue'

const router = {
  name: 'licenses',
  path: 'licenses',
  component: MainPage,
  children: [
    {
      path: '/licenses-manager',
      name: 'licensesManager',
      component: ManagerLanding,
      meta: {
        requiresAuth: true,
      
        action: 72 ,
        titleHeader: 'Licencias'
      }
    },
    {
      path: '/licenses-manager',
      name: 'licensesManager',
      component: ManagerLanding,
      meta: {
        requiresAuth: true,
      
        action: 71 ,
        titleHeader: 'Licencias'
      }
    },
    {
      path: '/pending-approval',
      name: 'pendingApproval',
      component: PendingApproval,
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        action: 71,
        titleHeader: 'Pendientes de aprobación'
      }
    },
    {
      path: '/licenses-search',
      name: 'licensesSearch',
      component: LicensesSearch,
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        action: 71,
        titleHeader: 'Consulta de solicitudes'
      }
    },
    {
      path: '/licenses-balances',
      name: 'licensesBalances',
      component: BalancesPage,
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        action: 91,
        titleHeader: 'Reporte de saldo'
      }
    },
    {
      path: '/licenses-holidays',
      name: 'licensesHolidays',
      component: HolidaysPage,
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        action: 92,
        titleHeader: 'Feriados'
      }
    },
    {
      path: '/',
      name: 'licenses',
      component: RequestMain,
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        action: 72,
        titleHeader: 'Licencias'
      }
    },
    {
      name: 'requestDetail',
      path: 'detail',
      component: HistoryLicenseDetail,
      props: true,
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        action: 72,
        titleHeader: 'Detalle de solicitud'
      }
    },
    {
      name: 'pendingDetail',
      path: 'pending-detail',
      component: PendingApprovalDetail,
      props: true,
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        action: 71,
        titleHeader: 'Detalle de solicitud'
      }
    },
    {
      path: '/manager-licenses-page',
      name: 'licensesManagerPage',
      component: LicensesManagerPage,
      meta: {
        requiresAuth: true,
        action: 71 ,
        titleHeader: 'Licencias'
      }
    }
  ],

  beforeEnter: (to, from, next) => {
    let user = store.getters.getUser
    let userIsApprovingProfile = false

    user.perfiles.forEach(profile => {
      if (profile.id_perfil_tipo === 5) {
        userIsApprovingProfile = true
      }
    })

    if (
      !userIsApprovingProfile &&
      (
        to.name === 'licensesSearch' ||
        to.name === 'licensesBalances' ||
        to.name === 'pendingApproval' ||
        to.name === 'licensesHolidays')
    ) {
      next('/licenses')
    }
    next()
  }
}

export default router
